import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import backimage from "../../assets/icons/prev.svg";
import { useLocation, useNavigate } from "react-router-dom";
import pen from "../../assets/icons/pen.svg";
import add from "../../assets/icons/add.svg";
import { Modal } from "antd";
const Populate = () => {
  const [editableText, setEditableText] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { data, nestedClasses } = location.state || {};

  const isItemBelongsToRoom = (item) => {
    for (const room of nestedClasses) {
      for (const roomItem of room.contains) {
        const adjustedX = item.x + item.width / 2;
        const adjustedY = item.y + item.height / 2;

        if (
          item.class === roomItem.class &&
          adjustedX >= roomItem.x &&
          adjustedY >= roomItem.y &&
          adjustedX <= roomItem.x + roomItem.width &&
          adjustedY <= roomItem.y + roomItem.height
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const handleClick = () => {
    setEditableText(!editableText);
  };

  const handleThemeNameChange = (editedText) => {
    // console.log(editedText);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="populate">
        <div className="back-container">
          <img
            src={backimage}
            className="back-image-styles"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
        </div>
        <h1 className="d-flex align-items-center gap-2">
          Floor <img src="/assets/icons/edit2.svg" alt="" />
        </h1>
        <div className="populate-content">
          <div className="left-populate">
            <div className="floor-right">
              <div className="room-and-items">
                <div className="room">
                  <h6 className="pb-4 text-center">Room</h6>
                  {data.map((item, index) => {
                    if (
                      [
                        "Living Room",
                        "Bedroom",
                        "kitchen",
                        "garage",
                        "Bathroom",
                        "Balcony",
                        "staircase",
                        "Wardrobe",
                        "DiningRoom",
                        "Staircase",
                        "Master Bedroom",
                        "office",
                        "StoreRoom",
                        "Utility",
                        "PrayerRoom",
                        "BalconyRailing",
                        "StudyRoom",
                        "Office",
                        "room",
                        "space",
                      ].includes(item.class)
                    ) {
                      return (
                        <div key={index} className="bedroom">
                          <p
                            onClick={(e) => {
                              if (editableText) {
                                e.target.setAttribute("contentEditable", true);
                              }
                            }}
                            onBlur={(e) => {
                              if (editableText) {
                                e.target.setAttribute("contentEditable", false);
                                handleThemeNameChange(e.target.innerText);
                              }
                            }}
                          >
                            {item.class}
                          </p>
                          <img src="/assets/icons/delete.svg" alt="" />
                        </div>
                      );
                    }
                  })}
                  <div className="buttons">
                    <div className="edit-button">
                      <img
                        onClick={handleClick}
                        src="/assets/icons/edit2.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="items">
                  <h6 className="pb-4 text-center">Items</h6>
                  {data?.map((item, index) => {
                    if (
                      ![
                        "Living Room",
                        "Bedroom",
                        "kitchen",
                        "garage",
                        "Bathroom",
                        "Balcony",
                        "staircase",
                        "Wardrobe",
                        "DiningRoom",
                        "Staircase",
                        "Master Bedroom",
                        "office",
                        "StoreRoom",
                        "Utility",
                        "PrayerRoom",
                        "BalconyRailing",
                        "StudyRoom",
                        "Office",
                        "room",
                        "Walls",
                        "door",
                        "window",
                        "space",
                      ].includes(item.class)
                    ) {
                      return (
                        <div key={index} className="bedroom">
                          <p
                            onClick={(e) => {
                              if (editableText) {
                                e.target.setAttribute("contentEditable", true);
                              }
                            }}
                            onBlur={(e) => {
                              if (editableText) {
                                e.target.setAttribute("contentEditable", false);
                                handleThemeNameChange(e.target.innerText);
                              }
                            }}
                          >
                            {isItemBelongsToRoom(item) ? (
                              <img src="/assets/icons/light.svg" alt="" />
                            ) : (
                              <img src="/assets/icons/socket.svg" alt="" />
                            )}
                            {item.class}
                          </p>
                          <img src="/assets/icons/delete.svg" alt="" />
                        </div>
                      );
                    }
                  })}
                  <div className="buttons">
                    <div className="edit-button">
                      <img
                        onClick={handleClick}
                        src="/assets/icons/edit2.svg"
                        alt=""
                      />
                    </div>
                    <div className="validate">
                      <button>Validate Items</button>
                    </div>
                  </div>
                </div>
                <div className="items comment  ">
                  <div className="w-100">
                    <h6 className="pb-4 text-center">Comments</h6>
                    <div className="bedroom">
                      <p> Comment</p>
                    </div>
                    <div className="bedroom dark-purple">
                      <p>Comment</p>
                      <img src={pen} alt="" className="pointer" />
                    </div>
                    <div className="bedroom"></div>
                    <div className="bedroom dark-purple">
                      <p>Comment</p>
                    </div>
                    <div className="bedroom"></div>
                    <div className="bedroom dark-purple"></div>
                  </div>
                  <img
                    src={add}
                    alt=""
                    className="pointer mt-5"
                    onClick={showModal}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="right-populate">
            <div className="floor-right">
              <div className="room-and-items">
                <div className="items product">
                  <div className="item-dropdown items-icon">
                    <Dropdown className="floor-dropdown">
                      <Dropdown.Toggle id="dropdown-basic">
                        <img src="/assets/icons/items.svg" alt="" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href="#/action-1">
                          Select Template Line
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-2">
                          Select Style / Colors
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Select Manufacturer
                        </Dropdown.Item>
                        <Dropdown.Item href="#/action-3">
                          Category
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <h6 className="pb-4 text-center ">Items</h6>
                  <div className="bedroom">
                    <p>
                      <img src="/assets/icons/light.svg" alt="" /> 1 Light
                    </p>
                    <img src="/assets/icons/add.svg" alt="" />
                  </div>
                  <div className="bedroom dark-purple">
                    <p>
                      <img src="/assets/icons/light.svg" alt="" /> @Lights
                    </p>
                    <img src="/assets/icons/add.svg" alt="" />
                  </div>
                  <div className="bedroom">
                    <p>
                      <img src="/assets/icons/light.svg" alt="" /> 1 Lights
                    </p>
                    <img src="/assets/icons/add.svg" alt="" />
                  </div>
                  <div className="bedroom dark-purple">
                    <p>
                      <img src="/assets/icons/socket.svg" alt="" /> 1 Electric
                      Socket
                    </p>
                    <img src="/assets/icons/add.svg" alt="" />
                  </div>
                  <div className="bedroom">
                    <p>
                      <img src="/assets/icons/light.svg" alt="" /> 2 Lights{" "}
                      <img src="/assets/icons/add.svg" alt="" />
                    </p>
                  </div>
                  <div className="bedroom dark-purple">
                    <p>
                      <img src="/assets/icons/socket.svg" alt="" /> 1 Electric
                      Socket
                    </p>
                    <img src="/assets/icons/add.svg" alt="" />
                  </div>
                  <div className="buttons product-btns validate-items">
                    <div className="validate validate-btns">
                      <button>
                        <img src="/assets/icons/import.svg" alt="" /> Import new
                        item
                      </button>
                      <button>+ Create new item</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered={true}
        footer={null}
        className="comment-modal"
      >
        <div className="comment-modal-content">
          <label>Add Comment</label>
          <textarea
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="Type here"
          ></textarea>
          <button className="btn-primary">Save</button>
        </div>
      </Modal>
    </>
  );
};

export default Populate;
